import { jsx as o } from "react/jsx-runtime";
import { u as r } from "./index-6a632112.mjs";
import "react";
const i = r.span`
  position: absolute;
  left: -9999px;
  width: 1px;
  height: 1px;
  overflow: hidden;
`, d = ({ children: t, ...e }) => /* @__PURE__ */ o(i, { ...e, children: t });
export {
  d as ScreenReaderOnly
};
